import React, { Suspense } from 'react';
import DesktopApp from './DesktopApp.js';
import selectors from './selectors/selectors.js';
import { useSelector } from 'react-redux';

const MobileApp = React.lazy(() => import('./mobile/MobileApp.js'));

const App = () => {
  const isMobile = useSelector(selectors.mobile);

  if (isMobile) {
    return (
      <Suspense fallback={<div />}>
        <MobileApp />
      </Suspense>
    );
  }

  return <DesktopApp />;
};

export default App;
